import { useCrossAccounts } from '../../../features/accounts';
import PortalIdParser from 'PortalIdParser';
export const usePortalAccounts = () => {
  const {
    crossAccounts,
    crossAccountsLoading: isLoading,
    crossAccountsError: error
  } = useCrossAccounts();
  const currentPortalId = PortalIdParser.getPortalIdFromPath();
  if (!crossAccounts) {
    return {
      currentAccount: null,
      remainingAccounts: null,
      isLoading,
      error
    };
  }
  const currentAccount = crossAccounts.accounts.find(account => account.id === currentPortalId) || null;
  const remainingAccounts = currentAccount ? crossAccounts.accounts.filter(account => account.id !== currentPortalId) : crossAccounts.accounts;
  return {
    currentAccount,
    remainingAccounts,
    isLoading,
    error
  };
};